import { render, staticRenderFns } from "./RowBlockSkeleton.vue?vue&type=template&id=32150aae&"
import script from "./RowBlockSkeleton.vue?vue&type=script&lang=js&"
export * from "./RowBlockSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports